import Api from './Api'
import axios from 'axios'
import InstillingerService from './InstillingerService'
// import Vue from 'vue'

export default {
  search (query, avdeling, page) {
    // Post data
    let post = {
      q: query
    }

    // Query
    let params = {
      params: {
        page: page || 1,
        sort: 'Auksjon_dato',
        direction: 'desc',
        limit: 150
      }
    }

    // And set avdeling in post
    if (avdeling !== null && avdeling !== undefined) {
      post.avdeling = avdeling
    }

    return Api().post('/auksjon/search.json',
      post,
      params
    )
  },

  searchInSettings (query, avdeling, datestate, sort, order, page) {
    // Post data
    let post = {
      q: query
    }

    // Query
    let params = {
      params: {
        page: page || 1,
        sort: sort || 'Auksjon_dato',
        direction: order || 'desc'
      }
    }

    // And set avdeling in post
    if (avdeling !== null && avdeling !== undefined) {
      post.avdeling = avdeling
    }

    if (datestate !== null) {
      post.datestate = datestate
    }

    return Api().post('/auksjon/search.json',
      post,
      params
    )
  },

  latestUnderhand (avdeling) {
    let post = {
      uh: true
    }

    if (avdeling !== null && avdeling !== undefined) {
      post.avdeling = avdeling
    }

    return Api().post('/auksjon/search.json',
      post,
      { params: { page: 1 } }
    )
  },

  latestAr (avdelingsId) {
    return Api().post('/auksjon/search.json',
      { ar: true, avdeling: avdelingsId },
      { params: { page: 1 } }
    )
  },

  latestFifty: function () {
    return Api().post('/auksjon/search.json',
      { latest: true },
      { params: { page: 1 } }
    )
  },

  searchOnObjektCreate (query, avdeling, page) {
    let post = {
      q: query,
      checkdate: 1
    }

    if (avdeling !== null && avdeling !== undefined) {
      post.avdeling = avdeling
    }

    return Api().post('/auksjon/search.json',
      post,
      { params: { page: page || 1 } }
    )
  },

  view (id) {
    return Api().get('/auksjon/load.json', {params: {id: id}})
    // return Api().get('/auksjon/' + id + '.json')
  },

  dropdown (key, type, avdeling, tilpassetHvor, rekkefolge, available) {
    let params = {}

    if (key) {
      params.key = key
    }

    if (type) {
      params.type = type
    }

    if (avdeling !== undefined) {
      params.avdeling = avdeling
    }

    if (available) {
      params.available = available
    }

    if (tilpassetHvor) {
      params.tilpassetHvor = tilpassetHvor
    }

    if (rekkefolge) {
      params.rekkefolge = rekkefolge
    }

    if (available) {
      params.available = available
    }

    return Api().get('/auksjon/dropdown.json', {
      params: params
    })
  },

  save (id, data) {
    if (!id) {
      return Api().post('/auksjon.json', data)
    }

    return Api().put('/auksjon/' + id + '.json', data)
  },

  loadFormDropdowns () {
    return new Promise((resolve, reject) => {
      axios
        .all([
          InstillingerService('auksjontype').dropdown(),
          InstillingerService('avdeling').dropdown()
        ])
        .then(
          axios.spread(function (auksjontype, avdeling) {
            let payload = {
              auksjontype: auksjontype.data,
              avdeling: avdeling.data
            }

            resolve(payload)
          })
        )
        .catch(error => {
          reject(error)
        })
    })
  },

  createForhandsbud (postData) {
    return Api().post('/forhandsbud.json', postData)
  },

  updateForhandsbud (id, postData) {
    return Api().put('/forhandsbud/' + id + '.json', postData)
  },

  deleteForhandsbud (id) {
    return Api().delete('/forhandsbud/' + id + '.json')
  },

  getSpader (code, queryParams) {
    return Api().get('/spader.json', {
      params: Object.assign({}, queryParams, { Auksjon: code })
    })
  },

  createSpade (postData) {
    return Api().post('/spader.json', postData)
  },

  updateSpade (id, postData) {
    return Api().put('/spader/' + id + '.json', postData)
  },

  deleteSpade (id) {
    return Api().delete('/spader/' + id + '.json')
  },

  createTelefonbud (postData) {
    return Api().post('/telefonbud.json', postData)
  },

  updateTelefonbud (id, postData) {
    return Api().put('/telefonbud/' + id + '.json', postData)
  },

  deleteTelefonbud (id) {
    return Api().delete('/telefonbud/' + id + '.json')
  },

  lookupCustomer: function (Auksjon, Tilslagnr) {
    return Api().get('/find_customer_in_auction.json', {
      params: {
        Auksjon: Auksjon,
        Tilslagnr: Tilslagnr
      }
    })
  },

  getNextClassical: function () {
    return Api().get('/auksjon/next-classical')
  },

  bidHistory (objectId, auctionId) {
    return Api().get('/objekt/gethistoryobjectbids/.json', {
      params: {
        objectId: objectId,
        auctionId: auctionId
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/AuksjonService.js